import styled, { css } from 'styled-components'
import media from '../../../../services/generateMediaQueries'

export const BannerCaption = styled.img`
  max-width: 42vw;
  max-height: 60vh;
  ${media.lessThan('small')`
    max-width: 82vw;
    max-height: 60vh;
  `}
`

export const ButtonNavWrapper = styled.div`
  position: absolute;
  top: calc(200px - (52px / 2));
  right: 6rem;

  ${props =>
    props.left &&
    css`
      right: unset;
      left: 6rem;
    `}

  ${media.lessThan('large')`
    right: 2rem;

    ${props =>
      props.left &&
      css`
        right: unset;
        left: 2rem;
      `}
  `}

  ${media.lessThan('medium')`
    display: none;
  `}
`

export const ButtonNav = styled.button`
  background: #ffffff;
  width: 3.25rem;
  height: 3.25rem;
  border-radius: 50%;
  outline: none;
  margin-right: 0.5rem;
  border: 1px solid var(--color-fg-lighter);
  font-size: 1.8rem;
  font-weight: var(--font-weight-bold);
  color: var(--color-fg-lighter);
  cursor: pointer;
  transition: all var(--animation-duration) var(--animation-easing);

  & > svg {
    margin-top: -5px;
    margin-left: ${props => (props.right ? 0 : '-5px')};
    margin-right: ${props => (props.right ? '-5px' : 0)};
  }

  :last-child {
    margin-right: 0;
  }

  :hover {
    background: var(--color-primary);
    border-color: transparent;
    color: white;
    transition: all var(--animation-duration) var(--animation-easing);
  }

  :focus {
    border-color: var(--color-primary);
    transition: all var(--animation-duration) var(--animation-easing);
  }
`

export const StyledBannerImage = styled.div`
  text-transform: uppercase;
  font-weight: var(--font-weight-black);
  font-size: 4rem;
  display: block;
  width: 100%;
  line-height: 1;
  letter-spacing: 0.2em;

  > * {
    display: block;
  }

  > :first-child {
    margin-left: -3rem;
  }

  > :first-child + * {
    margin-left: 3rem;
    font-size: 0.75em;
  }

  ${media.lessThan('medium')`
    font-size: 2.5rem;
    text-align: center;

    > :first-child {
      margin-left: 0;
    }

    > :first-child + * {
      margin-left: 0;
      font-size: 0.75em;
    }
  `}
`
